import BaseModel, {defineTranslatableProperties} from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";


export default class UserSearch extends BaseModel {
  first_name = null;
  last_name = null;
  email = null;
  is_blocked = null;
  branch_uuid = null;
  show_blocked = false;

  rules = {};

  attributeLabels = {
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    email: i18n.t('Email'),
    is_blocked: i18n.t('Blocked'),
    branch_uuid: i18n.t('Branch'),
    show_blocked: i18n.t('Show Blocked')
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    if (!data.is_blocked) {
      delete data.is_blocked
    }
    if (!data.branch_uuid) {
      delete data.branch_uuid
    }
    return data
  }
}

defineTranslatableProperties(UserSearch);
